import axios from 'axios'
import qs from 'qs'
import router from '../router/index'
import ElementUI, { Message, MessageBox } from 'element-ui';
const resOk = 200 //请求成功的状态值

//创建一个axios的对象
const instance = axios.create({
  // baseURL: 'http://localhost:8012', // 龙哥
  baseURL: 'http://139.9.149.243:8012',
  timeout: 100000000000 //请求超时
})


instance.interceptors.request.use(config => {
  if (localStorage.getItem("token")) {
    let token = localStorage.getItem("token")
    config.headers.Authorization = token
  }
  return config
},
  (err) => {
    return Promise.reject(err)
  }
)

//响应拦截:所有网络请求返回数据之后都会执行这个方法
//用法:此处可以根据服务器的返回状态码做响应的数据
instance.interceptors.response.use(response => {
  if (response.data.code == 200) {
    return response
  }
  Message({
    message: response.data.msg,
    type: 'error',
    duration: 2000
  })
},
  (err) => {
    console.log(err)
    return Promise.reject(err)
  }
)


//get请求
export function get(url, params) {
  return function (params) {
    return instance.get(url, { params })
      .then(res => {
        const status = res.status
        const data = res.data
        if (status === resOk) {
          //请求成功
          if (data.msg == "token验证失效") {
            Message({
              message: '用户登录失效',
              type: 'error',
              duration: 2000
            })
            localStorage.clear()
            router.push('/login')
          }
          return data
        }
      })
      .catch(e => {
        console.log('我get请求我报错了')
      })
  }
}
//post请求
export function post(url, data) {
  return function (data) {
    const transmitVal = qs.stringify(data)
    return instance.post(url, transmitVal)
      .then(res => {
        const status = res.status
        const data = res.data
        if (data.msg == "token验证失效") {
          Message({
            message: '用户登录失效',
            type: 'error',
            duration: 2000
          })
          localStorage.clear()
          router.push('/login')
        }
        return data
      })
      .catch(e => {
        console.log('我post请求我报错了')
      })
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js